<template>
    <div class="dialog-advanced-filter" v-if="show">
        <div class="dialog-advanced-filter__header">
            <span class="dialog-advanced-filter__title">
                {{ translate('btn_advanced_filters') }}
            </span>
            <div class="dialog-advanced-filter__action">
                <el-link v-if="hasFilters" @click="clearFilters">
                    {{ translate('clear_filters') }}
                </el-link>
                <el-link @click="$emit('applyFilter')">
                    {{ translate('apply_filters') }}
                </el-link>
            </div>
        </div>
        <div class="dialog-advanced-filter__content">
            <el-form>
                <el-collapse v-model="collapseSelected">
                    <el-collapse-item
                        :title="translate('company')"
                        name="1"
                    >
                        <el-select
                            v-model="filter.selectedCompanyId"
                            :placeholder="translate('select_company')"
                            filterable
                            clearable
                            @change='handleFilterChange'
                            :remote-method="filterCompanies"
                        >
                            <el-option
                                v-for="item in filteredCompanies"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                                {{ item.name }}
                            </el-option>
                        </el-select>
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('warehouse_type')"
                        name="2"
                    >
                        <el-checkbox-group
                            v-model='filter.warehouseType'
                            class=""
                            @change='handleFilterChange'
                            :max="1"
                        >
                            <el-checkbox :label="warehouseType.SILO" class="checkbox-area_view-invoice-filter">
                                {{ getFaciltyType(warehouseType.SILO) }}
                            </el-checkbox>
                            <el-checkbox :label="warehouseType.PORTO" class="checkbox-area_view-invoice-filter">
                                {{ getFaciltyType(warehouseType.PORTO) }}
                            </el-checkbox>
                            <el-checkbox :label="warehouseType.ESCRITORIO" class="checkbox-area_view-invoice-filter">
                                {{ getFaciltyType(warehouseType.ESCRITORIO) }}
                            </el-checkbox>
                            <el-checkbox :label="warehouseType.FABRICA" class="checkbox-area_view-invoice-filter">
                                {{ getFaciltyType(warehouseType.FABRICA) }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { WarehouseTypeEnum } from '@/modules/warehouse/constants/WarehouseTypeEnum';

export default {
    name: 'dialog-advanced-filters',
    data() {
        return {
            warehouseType: WarehouseTypeEnum,
            collapseSelected: [1],
            filter: {
                selectedCompanyId: null,
                warehouseType: []
            }
        };
    },
    props: {
        show: {
            type: Boolean,
            required: true,
            default: () => false
        }
    },
    mounted() {
        this.$emit('handleFilter', this.filter, true);
        if (this.empresasSubEmpresasPorPais.length === 0) {
            this.fetchCompaniesAndSubCompanies();
        } else {
            this.filteredCompanies = this.empresasSubEmpresasPorPais;
        }
    },
    computed: {
        ...mapGetters(['empresasSubEmpresasPorPais', 'usuarioLogado']),
        hasFilters() {
            return (
                this.filter.selectedCompanyId || this.filter.warehouseType.length > 0
            );
        }
    },
    methods: {
        ...mapActions(['fetchEmpresasSubEmpresasPorPais']),

        translate(key, params = {}) {
            const base = 'warehouse.warehouse_list_page.main_filter';
            return this.$t(`${base}.${key}`, params);
        },
        getFaciltyType(type) {
            if (!type || type === '') return '-';
            return this.$t(`warehouse.messages.facility_types.${type.toLowerCase()}`);
        },
        handleFilterChange() {
            this.$emit('handleFilter', this.filter, false);
        },
        clearFilters() {
            this.filter.selectedCompanyId = null;
            this.filter.warehouseType = [];
            this.$emit('clear');
        },
        async fetchCompaniesAndSubCompanies() {
            if (this.empresasSubEmpresasPorPais.length === 0) {
                await this.fetchEmpresasSubEmpresasPorPais(this.usuarioLogado.paisGrupo ? this.usuarioLogado.paisGrupo : 'PY');
            }
            this.filteredCompanies = this.empresasSubEmpresasPorPais;
        },
        filterCompanies(searchtext) {
            this.filteredCompanies = this.empresasPorPais.filter(company =>
                company.name.toLowerCase().includes(searchtext.toLowerCase())
            );
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-advanced-filter {
    width: 100%;

    .dialog-advanced-filter__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .dialog-advanced-filter__title {
            font-weight: 500;
            font-size: 16px;
            color: #00413c;
        }

        .dialog-advanced-filter__action {
            display: flex;
            gap: 16px;

            .el-link:first-child {
                color: #e35e58;
                font-size: 14px;
                font-weight: 400;
            }

            .el-link:last-child {
                color: #036be4;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }

    .dialog-advanced-filter__content {
        .dialog-advanced-filter__content__status {
            display: grid;
            grid-template-columns: 1fr 1fr auto;
            gap: 16px;
        }

        .dialog-advanced-filter__content__cultivation {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            gap: 32px;
        }
    }
}

.checkbox-area_view-invoice-filter {
    padding: 0 12px 0 0;
}
</style>
